export default __webpack_public_path__ + "static/media/2.eb3783b1.jpg";